import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Items = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'item_type', label: 'Type' },
    { key: 'grade', label: 'Grade' },
    { key: 'color', label: 'Color' },
    { key: 'category', label: 'Category' },
    { key: 'status', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'ITM001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Item Name' },
    { 
      name: 'item_type', 
      label: 'Item Type', 
      required: true,
      type: 'select',
      options: [
        { value: 'MASTERBATCH', label: 'Masterbatch' },
        { value: 'REGRINDING', label: 'Regrinding' },
        { value: 'RAW_MATERIAL', label: 'Raw Material' },
        { value: 'BOUGHT_OUT_PARTS', label: 'Bought Out Parts' },
      ]
    },
    { name: 'grade', label: 'Grade', placeholder: 'Grade' },
    { name: 'color', label: 'Color', placeholder: 'Color' },
    { name: 'category', label: 'Category', placeholder: 'Category' },
    { name: 'hsn_code', label: 'HSN Code', placeholder: 'HSN Code' },
    { name: 'uom_id', label: 'UOM', type: 'related-select', relatedKey: 'uoms', optionLabel: (o) => `${o.code} - ${o.name}` },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'ACTIVE',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
        { value: 'DISCONTINUED', label: 'Discontinued' },
      ]
    },
    { name: 'min_stock', label: 'Min Stock', type: 'number', placeholder: '0' },
    { name: 'max_stock', label: 'Max Stock', type: 'number', placeholder: '0' },
    { name: 'reorder_level', label: 'Reorder Level', type: 'number', placeholder: '0' },
  ];

  const transformSubmit = (data) => ({ ...data, is_active: data.status === 'ACTIVE' });

  return (
    <MasterLayout
      title="Items"
      endpoint="items"
      columns={columns}
      formFields={formFields}
      relatedEndpoints={{ uoms: 'uoms' }}
      transformSubmit={transformSubmit}
      permissions={['ADMIN', 'RM_STORE']}
    />
  );
};

export default Items;
